import { createApiRef } from '@backstage/core-plugin-api';
import type {
  Notice,
  NoticeInput,
  NoticeUpdate,
} from '@internal/backstage-plugin-neo4j-notices-common';

export type { Notice, NoticeInput, NoticeUpdate };

export type NoticesApi = {
  listNotices(): Promise<Notice[]>;
  createNotice(input: NoticeInput): Promise<Notice>;
  updateNotice(id: string, update: NoticeUpdate): Promise<Notice>;
  deleteNotice(id: string): Promise<void>;
  dismissNotice(id: string): Promise<void>;
};

export const noticesApiRef = createApiRef<NoticesApi>({
  id: 'plugin.neo4j-notices.service',
});
